import React, { forwardRef } from 'react'

import ReceiptEdit from '@/modules/receipt/receipt-edit'

const ReceiptReviewWorkspace = forwardRef((props: React.ComponentPropsWithoutRef<typeof ReceiptEdit>, ref) => (
  <ReceiptEdit {...props} ref={ref} />
))

ReceiptReviewWorkspace.displayName = 'ReceiptReviewWorkspace'

export default ReceiptReviewWorkspace
